(() => {
  if (customElements.get('sss-power-specs')) return;
  const numbers = new Intl.NumberFormat('en-CA', {useGrouping: true, maximumFractionDigits: 6});
  const converted = new Intl.NumberFormat('en-CA', {useGrouping: true, maximumFractionDigits: 2});
  customElements.define('sss-power-specs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.button = this.querySelector('[data-units-toggle]');
      if (!this.button) return;
      this.initialized = true;
      this.imperial = false;
      this.updateUnits();
      this.button.hidden = !this.querySelector('[data-unit="kg"], [data-unit="mm"], [data-unit="c"]');
      this.button.addEventListener('click', () => {
        this.imperial = !this.imperial;
        this.updateUnits();
      });
    }
    updateUnits() {
      this.querySelectorAll('[data-sss-number]').forEach((node) => {
        const raw = node.dataset.sssNumber;
        if (raw === undefined || !raw.trim()) return;
        let value = Number(raw);
        if (!Number.isFinite(value)) return;
        const unit = node.dataset.unit;
        if (this.imperial) {
          if (unit === 'kg') value /= 0.45359237;
          else if (unit === 'mm') value /= 25.4;
          else if (unit === 'c') value = value * 9 / 5 + 32;
        }
        node.textContent = (this.imperial && unit ? converted : numbers).format(value);
      });
      this.querySelectorAll('[data-metric-label]').forEach((node) => {
        node.textContent = this.imperial ? node.dataset.imperialLabel : node.dataset.metricLabel;
      });
      this.button.setAttribute('aria-pressed', String(this.imperial));
      this.button.textContent = this.imperial ? this.button.dataset.metric : this.button.dataset.imperial;
    }
  });
})();
